import { CodeMap } from 'adminConsole/codeMap'
import { service } from './service'
import { errorHandler } from 'share/util/common'

class CodeMapStroe {
  private _codeMapList: CodeMap[] = []

  get codeMapList() {
    return this._codeMapList
  }

  getCodeMapList = async () => {
    const res = await service.getCodeMapList()

    if (!res.ok) await errorHandler(res)

    this._codeMapList = await res.json()
  }
}

export const codeMapStore = new CodeMapStroe()
